import classnames from 'classnames';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import React, { useCallback, useState } from 'react';
import { LayoutFooter } from '../Layout';
import { preventDefault } from '../../../../common/utils';
import Button from '../../../../components/Button';
import { Review } from './Review';
import { Payment } from './Payment';
import { Order } from './Order';
const REVIEW_TAB = 0;
const PAYMENT_TAB = 1;
const ORDER_TAB = 2;
export const ReviewAndPayment = ({ fields, updateFields, navigateToSection, previousSection, finishCallback, onLoading, isLoading }) => {
    const [tabIndex, setTabIndex] = useState(REVIEW_TAB);
    const updateTabIndex = useCallback((index) => () => {
        window.scrollTo(0, 0);
        setTabIndex(index);
    }, [setTabIndex]);
    const backToPrevious = useCallback(preventDefault(previousSection), [previousSection]);
    return (React.createElement("div", { className: "reviewAndPayment" },
        React.createElement(Tabs, { selectedIndex: tabIndex, onSelect: setTabIndex, className: ['register-tabs'], selectedTabClassName: "register-tabs__tab--selected" },
            React.createElement(TabList, { className: classnames('register-tabs__tab-list', { 'register-tabs__tab-list--displayed': tabIndex >= 1 }) },
                React.createElement(Tab, { className: ['register-tabs__tab', 'register-tabs__tab--hidden'] }, "Review Order"),
                React.createElement(Tab, { className: ['register-tabs__tab'] }, "Payment Info"),
                React.createElement(Tab, { className: ['register-tabs__tab'], disabled: true }, "Place Order")),
            React.createElement(TabPanel, null,
                React.createElement(Review, { fields: fields, navigateToSection: navigateToSection })),
            React.createElement(TabPanel, null,
                React.createElement(Payment, { fields: fields, updateFields: updateFields, onLoading: onLoading, onBack: updateTabIndex(REVIEW_TAB), onSubmit: updateTabIndex(ORDER_TAB) })),
            React.createElement(TabPanel, null,
                React.createElement(Order, { fields: fields, updateFields: updateFields, finishCallback: finishCallback, onLoading: onLoading, isLoading: isLoading }))),
        tabIndex === REVIEW_TAB && (React.createElement(LayoutFooter, { positionShouldChange: true },
            React.createElement(Button, { variant: "marketing-border", type: 'button', onClick: backToPrevious }, "Go Back"),
            React.createElement(Button, { variant: "marketing-solid", type: 'button', onClick: updateTabIndex(PAYMENT_TAB) }, "Payment"))),
        tabIndex === ORDER_TAB && (React.createElement(LayoutFooter, { positionShouldChange: true },
            React.createElement(Button, { variant: "marketing-border", type: 'button', onClick: updateTabIndex(PAYMENT_TAB) }, "Back to payment")))));
};
